export default {"src":"/_next/static/media/survey.8b6d6601.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};